<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_3"></a><span class="blue">Contents</span></h2>
<p class="toc-entry"><a href="#/xhtml/dedication">Dedication</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter01">Acknowledgments</a></p>
<p class="toc-entry"><a href="#/xhtml/frontmatter02">Preface</a></p>
<p class="toc-entry"><a href="#/xhtml/chapter01">Inspiration and Learning</a></p>
<p class="toc-entry"><span href="#/xhtml/chapter02" title="Link target outside of Sample">My Favorite Tools</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter03" title="Link target outside of Sample">Designing with Free-Form Shapes</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter04" title="Link target outside of Sample">Fillers: The Space between the Lines</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05" title="Link target outside of Sample">Color and Contrast</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06" title="Link target outside of Sample">Illusions</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter07" title="Link target outside of Sample">Freezer-Paper Foundation Piecing</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter08" title="Link target outside of Sample">Gallery Quilts</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter09" title="Link target outside of Sample">Projects</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter09" title="Link target outside of Sample"><em>Star Fragments</em></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter10" title="Link target outside of Sample"><em>Tiny Trees</em></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter11" title="Link target outside of Sample"><em>Facing the Sun</em></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter12" title="Link target outside of Sample"><em>Rueda de la Fortuna</em></span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter13" title="Link target outside of Sample"><em>Winding Ways</em></span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter02" title="Link target outside of Sample">Resources</span></p>
<p class="toc-entry"><span href="#/xhtml/backmatter01" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?e41afc6e